<template>
  <el-container class="PersonnelVehicleInformation">
    <!-- 单位信息 -->
    <el-card class="tree-card" :body-style="treeCard">
      <div class="tree-box">
        <el-card
          :class="{ hoverCard: leftListIndex === index }"
          v-for="(item, index) in leftList"
          :key="index"
          shadow="always"
          @click="leftClick(item, index)"
        >
          <div class="mycard">
            <span>
              {{
                item.state === "1"
                  ? "待关怀"
                  : item.state === "2"
                  ? "已关怀"
                  : item.state === "3"
                  ? "忽略"
                  : item.state === "4"
                  ? "误报"
                  : "全部"
              }}
            </span>
            <span>{{ item.num }}</span>
          </div>
        </el-card>
      </div>
    </el-card>
    <el-card class="tabs-card">
      <el-form
        :inline="true"
        ref="formRef"
        :model="tableParams"
        class="demo-form-inline"
      >
        <el-form-item label="任务名称" prop="dutyName">
          <el-input
            v-model="tableParams.dutyName"
            placeholder="任务名称"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="任务类型" prop="dutyType">
          <el-select
            clearable
            v-model="tableParams.dutyType"
            placeholder="任务类型"
          >
            <el-option
              v-for="item in [
                { name: '走访关怀', value: '1' },
                { name: '去电关怀', value: '2' },
              ]"
              :key="item.name"
              :label="item.name"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="时间" prop="endTime">
          <!-- <h-date-timerange
            type="date"
            v-model:end="tableParams.endTime"
            v-model:start="tableParams.sortField"
          >
          </h-date-timerange> -->
          <el-date-picker
            v-model="tableParams.dutyTime"
            type="date"
            style="width: 100%"
            value-format="YYYY-MM-DD"
          />
        </el-form-item>
        <el-form-item label="状态" prop="state">
          <el-select v-model="tableParams.state" class="m-2" placeholder="状态">
            <el-option
              v-for="item in [
                { value: '', name: '全部' },
                { value: '1', name: '待关怀' },
                { value: '2', name: '已关怀' },
                { value: '3', name: '忽略' },
                { value: '4', name: '误报' },
              ]"
              :key="item.value"
              :label="item.name"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <h-button type="primary" @click="refreshTable()">查询</h-button>
          <h-button @click="resetForm(formRef)">重置</h-button>
        </el-form-item>
      </el-form>
      <div class="table-box">
        <h-table
          ref="tableRef"
          v-model:data="tableData"
          v-model:columns="columns"
          :method="querydutyDetail"
          :params="tableParams"
          @handleClick="handleClick"
          @select="hzTableSelect"
        >
          <template #state="{ row }">
            <span>{{
              row.state === "1"
                ? "待关怀"
                : row.state === "2"
                ? "已关怀"
                : row.state === "2"
                ? "忽略"
                : "误报"
            }}</span>
          </template>
          <template #dutyType="{ row }">
            <span>{{ row.dutyType === "1" ? "走访关怀" : "去电关怀" }}</span>
          </template>
          <template #imageUrl="{ row }">
            <span v-if="row.imageUrl">
              <img :src="imgURL + row.imageUrl"
            /></span>
            <img v-else :src="imgURL + row.imageUrl" />
          </template>
          <template #operate="{ row }">
            <div>
              <el-button
                v-if="row.state === '1'"
                size="small"
                plain
                @click="handleClick('wb', row)"
                >误报</el-button
              >
              <el-button
                v-if="row.state === '1'"
                size="small"
                plain
                @click="handleClick('edit', row)"
                >关怀登记</el-button
              >
              <el-button size="small" plain @click="handleClick('xq', row)"
                >详情</el-button
              >
            </div>
          </template>
        </h-table>
      </div>
    </el-card>
    <el-dialog v-model="formVisible" title="关怀任务" width="25%">
      <careregistrationAdd
        :from="userFormData"
        @cancel="cancel"
      ></careregistrationAdd>
    </el-dialog>
    <el-dialog v-model="detialVisible" title="任务详情" width="25%">
      <careregistrationDetial
        v-model:form="detialForm"
      ></careregistrationDetial>
    </el-dialog>
  </el-container>
</template>
<script>
import { defineComponent, nextTick, reactive, toRefs, ref } from "vue";
import { ElMessageBox, ElMessage } from "element-plus";
import careregistrationAdd from "@/views/communityCare/components/communityMissionDetails/careregistrationAdd.vue";
import careregistrationDetial from "@/views/communityCare/components/communityMissionDetails/careregistrationDetial.vue";
import { getMenutree } from "@/api/system/region.js";

import {
  statisticsDutyDetail,
  querydutyDetail,
  handledutyDetail,
} from "@/api/communityCare/communityCareApi.js";

import _ from "lodash";
export default defineComponent({
  name: "",
  components: { careregistrationAdd, careregistrationDetial },
  props: {},
  setup(props) {
    const state = reactive({
      imgURL: window.imgURL,
      filterText: "",
      rootNodeKey: "",
      treeCard: {
        height: "100%",
        display: "flex",
        flexDirection: "column",
      },
      dataSource: [],
      userFormData: {},
      leftListIndex: 0,
      leftList: [
        {
          state: "",
          num: "0",
        },
        {
          state: "1",
          num: "0",
        },
        {
          state: "2",
          num: "0",
        },
        {
          state: "3",
          num: "0",
        },
        {
          state: "4",
          num: "0",
        },
      ],
      tableParams: {
        dutyName: "",
        dutyType: "",
        state: "",
        dutyTime: "",
        // endTime: "",
        // sortField: "",
      },
      tableData: [],
      formStatus: 1, // 1 添加  2 编辑
      formVisible: false,
      detialVisible: false,
      detialForm: {},
      columns: [
        { type: "selection" },
        {
          label: "人员照片",
          slot: "imageUrl",
        },
        {
          label: "姓名",
          prop: "name",
        },
        {
          label: "性别",
          prop: "sex",
        },
        {
          label: "民族",
          prop: "nationType",
        },
        {
          label: "居住地",
          prop: "registerDetail",
        },
        {
          label: "任务名称",
          prop: "dutyName",
        },
        {
          label: "任务类型",
          slot: "dutyType",
        },
        {
          label: "电话",
          prop: "telphone",
        },
        {
          label: "状态",
          slot: "state",
        },
        {
          label: "操作",
          slot: "operate",
          width: "150px",
        },
      ],
    });
    const refData = toRefs(state);
    // const treeRef = ref(null);
    const tableRef = ref(null);
    const formRef = ref(null);
    // 对组织树节点进行筛选时执行的方法
    const filterNode = (value, data, node) => {
      if (!value) return true;
      return data.label.indexOf(value) !== -1;
    };
    // 当前选中节点变化时触发的事件
    const currentChange = (item, nodes) => {
      state.currentNode = item;
      state.tableParams.deptId = item.deptId;
      state.userFormData.parentId = item.deptId;
      nextTick(() => {
        tableRef.value && tableRef.value.refresh();
      });
    };
    // 获取结构树
    const queryOrganTreAsync = async () => {
      const result = await getMenutree();
      const treeData = [result.data];
      state.dataSource = treeData;
      if (treeData[0]) {
        currentChange(treeData[0]);
        nextTick(() => {
          state.rootNodeKey = state.currentNode.id;
          // treeRef.value.setCurrentKey(state.currentNode.deptId);
        });
      }
    };
    queryOrganTreAsync();
    // 点击查询按钮
    const refreshTable = () => {
      state.leftListIndex = Number(state.tableParams.state);
      tableRef.value && tableRef.value.refresh();
    };
    // 重置表单
    const resetForm = (formEl) => {
      if (!formEl) return;
      formEl.resetFields();
      state.tableParams.dutyTime = "";
    };
    // 表单提交
    const userSubmit = () => {
      tableRef.value && tableRef.value.refresh();
    };
    // 点击table操作按钮
    const handleClick = (emitKey, row) => {
      if (emitKey === "edit") {
        // 编辑
        state.formStatus = 2; // 把表单设置为编辑状态
        state.userFormData = _.cloneDeep(row);
        state.formVisible = true;
        nextTick(() => {});
      } else if (emitKey === "wb") {
        // 误报
        ElMessageBox.confirm("您确认要误报该任务吗？", "暂停", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }).then(
          async () => {
            const res = await handledutyDetail(row.dutyDetailId);
            if (res.code === 0) {
              refreshTable();
              ElMessage({
                type: "success",
                message: "误报成功",
              });
            }
          },
          () => {}
        );
      } else if (emitKey === "xq") {
        // 详情
        state.detialVisible = true;
        state.detialForm = row;
      }
    };
    // 当用户手动勾选数据行的 Checkbox 时触发的事件
    const hzTableSelect = (selection) => {
      state.tableSelection = selection;
    };
    const clickTable = async (item) => {
      state.userFormData = _.cloneDeep(item);
      state.formStatus = 2;
      state.formVisible = true;
    };
    // 左侧
    const statisticsDutyInfoAxios = async () => {
      const res = await statisticsDutyDetail();
      res.data.forEach((item, index) => {
        state.leftList.forEach((element, inde) => {
          if (element.state == item.state) {
            element.num = item.num;
          }
        });
      });
      console.log(state.leftList, "000000");
      state.leftList[0].num = state.leftList.reduce(function (
        prev,
        cur,
        index,
        array
      ) {
        return prev + Number(cur.num);
      },
      0);
      console.log(state.leftList);
    };
    statisticsDutyInfoAxios();
    const leftClick = (item, index) => {
      state.leftListIndex = index;
      state.tableParams.state = item.state;
      refreshTable();
    };
    const cancel = () => {
      state.formVisible = false;
      refreshTable();
    };
    return {
      ...refData,
      cancel,
      leftClick,
      clickTable,
      filterNode,
      currentChange,
      refreshTable,
      resetForm,
      hzTableSelect,
      handleClick,
      userSubmit,
      querydutyDetail,
      formRef,
      tableRef,
    };
  },
});
</script>
<style lang="scss" scoped>
.PersonnelVehicleInformation {
  .tree-card {
    height: 100%;
    width: 300px;
    .input-with-select {
      margin-bottom: 10px;
    }
    .tree-box {
      flex: 1;
      overflow: auto;
      position: relative;
      .hoverCard {
        // background: red;
        border: 1px solid #3a74fb;
        border-left: 5px solid #3a74fb;
        color: #3a74fb;
      }
      .el-card {
        margin: 10px 0 !important;
        :deep(.el-card__body) {
          display: flex !important;
          justify-content: space-around !important;
          cursor: pointer;
        }
        .mycard {
          display: flex !important;
          justify-content: space-between;
        }
      }
      .tree-header {
        position: sticky;
        top: 0;
        z-index: 2;
        padding: 10px 0;
        background-color: var(--el-color-white);
        color: var(--el-text-color-regular);
        @include flex-row-sb-c;
        .tree-name {
          flex: 1;
          margin-right: 10px;
          padding-left: 48px;
        }
        .tree-status {
          width: 50px;
        }
      }
    }
  }
  .tabs-card {
    flex: 1;
    margin-left: 10px;
    .tabs-tabel-box {
      display: flex;
      flex-direction: column;
      overflow: hidden;
    }
    .table-box {
      flex: 1;
      overflow: hidden;
      img {
        width: 42%;
        height: 90px;
      }
      .table-role {
        color: #294a7c;
        cursor: pointer;

        text-align: center;
        span {
          border-bottom: 1px solid;
        }
      }
    }
  }
}
</style>
